import generators from './generators';
import helpers from './helpers';
import predicates from './predicates';
import properties from './properties';
import specs from './specs';
import transformers from './transformers';
import runners from './runners';

module.exports = () => ({
  generators, helpers, predicates, properties, specs, transformers, runners
});
